import EditMonitoringCard from '../../../../components/EditMonitoringCard/EditMonitoringCard';
import { IMonitoring } from '../../../../shared/interfaces/IMonitoring';
import ReviewMonitoringService from '../../../../services/ReviewMonitoringService';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import Section from '../../../../components/Main/Section/Section';
import { CurrentViewContext } from '../../../../providers/CurrentViewProvider';
import { useTranslation } from 'react-i18next';
import { Box, LinearProgress, useTheme } from '@mui/material';
import PlatformService from '../../../../services/PlatformService';
import { IPlatform } from '../../../../shared/interfaces/IPlatform';

const ContentContainer = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing(2)};
  grid-template-columns: repeat(3, 1fr);
`;

const EditMonitoring = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [monitoring, setMonitoring] = useState<IMonitoring[]>([]);
  const [platforms, setPlatforms] = useState<IPlatform[]>([]);
  const { t } = useTranslation();
  const { setCurrentView } = useContext(CurrentViewContext);

  useEffect(() => {
    setCurrentView(t('edit_monitoring'));
    document.title = `${t('app_branding')} ${t('edit_monitoring')}`;
  }, [setCurrentView, t]);

  const reload = async () => {
    await getMonitoring(new AbortController());
  };

  const getMonitoring = async (controller: AbortController) => {
    const monitoring: IMonitoring[] = await ReviewMonitoringService.getMonitoring(
      true,
      'both',
      setLoading,
      controller.signal
    );
    if (!monitoring) return;
    monitoring.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
    setMonitoring(monitoring);
  };

  useEffect(() => {
    const controller = new AbortController();

    (async () => await getMonitoring(controller))();
    PlatformService.getPlatforms(setLoading, controller.signal).then((response) => {
      if (response) setPlatforms(response);
    });

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <Section>
      {loading ? (
        <Box>
          <LinearProgress sx={{ my: theme.spacing(1) }} />
        </Box>
      ) : (
        <ContentContainer>
          {monitoring.map((monitoringEntry) => {
            return (
              <EditMonitoringCard
                key={monitoringEntry.id}
                id={monitoringEntry.id}
                companyName={monitoringEntry.company}
                label={monitoringEntry.label}
                minDaysPast={monitoringEntry.minDaysPast}
                createdAt={monitoringEntry.createdAt}
                updatedAt={monitoringEntry.updatedAt}
                jobs={monitoringEntry.jobs}
                url={monitoringEntry.url}
                platformId={monitoringEntry.platformId}
                platformLabel={
                  platforms.find((platform) => platform.id === monitoringEntry.platformId)?.label
                }
                communitySettings={monitoringEntry.communityManagement}
                reload={reload}
              />
            );
          })}
        </ContentContainer>
      )}
    </Section>
  );
};

export default EditMonitoring;
